import { Button, Modal as BootstrapModal } from 'react-bootstrap';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

import TextBox from '../controls/form/TextBox';
import Product from '../../services/product';
import PubSub from '../../services/PubSub';
import Dropdown from '../controls/form/Dropdown';

const CreateProductVersion = ({ show, products, onCancel }) => {
    const [translate] = useTranslation();

    const create = useCallback(async ({ product, version }) => {
        const response = await Product.createProductVersion(product, { version });
        if (!response.error) {
            onCancel();
            PubSub.publish('refresh-product-list');
        }
    }, [onCancel]);

    return (
        <BootstrapModal show={show} backdrop='static'>
            <Formik
                initialValues={{
                    version: '',
                    product: '',
                }}
                validationSchema={Yup.object({
                    version: Yup.string().min(3, translate('OTM_CHARACTERS_OR_MORE', { minCharacters: 3 })).required(' ')
                })}
                onSubmit={create}>
                <Form>
                    <BootstrapModal.Header className='h5 text-secondary'>{translate('OTM_CREATE_PRODUCT_VERSION')}</BootstrapModal.Header>
                    <BootstrapModal.Body>
                        <Dropdown
                            name='product'
                            options={products}
                            heading={translate('OTM_SELECT_PRODUCT')}
                            grow={true}
                        />
                        <TextBox label={translate('OTM_NAME')} type='text' name='version' css='mt-3' />
                    </BootstrapModal.Body>
                    <BootstrapModal.Footer>
                        <Button type='submit' className='btn-sm'>{translate('OTM_CREATE')}</Button>
                        <Button onClick={onCancel} variant='secondary' className='btn-sm'>{translate('OTM_CANCEL')}</Button>
                    </BootstrapModal.Footer>
                </Form>
            </Formik>
        </BootstrapModal>
    );
};

export default CreateProductVersion;